import { AxiosRequestConfig } from "axios";

export type IServerResponse<T> = {
  success: boolean;
  message: null | string;
  data: null | T;
  statusCode: number;
  errorResponse: any;
};

export type HeaderOptions = {
  token: string;
} & HeadersInit;

export type RequestOptions = AxiosRequestConfig<any> & {
  params?: object;
  /** A Headers object, an object literal, or an array of two-item arrays to set request's headers. */
  headers?: HeaderOptions;
  /** An AbortSignal to set request's signal. Allows you to abort one or more Web requests as and when desired. */
  signal?: AbortSignal | null;
};

/** `page` + `limit` list query pair (many OpenAPI list endpoints require both). Default: page 1, 20 rows. */
export type TPaginationQuery = {
  page: number;
  limit: number;
};

/** Optional pagination overrides merged with {@link defaultPaginationQuery}. */
export type TPaginationQueryPartial = Partial<TPaginationQuery>;

export const DEFAULT_LIST_PAGE = 1;
export const DEFAULT_LIST_PAGE_SIZE = 20;

export const defaultPaginationQuery = (): TPaginationQuery => ({
  page: DEFAULT_LIST_PAGE,
  limit: DEFAULT_LIST_PAGE_SIZE,
});

export const mergePaginationQuery = (
  partial?: TPaginationQueryPartial,
): TPaginationQuery => {
  const d = defaultPaginationQuery();
  return {
    page: partial?.page ?? d.page,
    limit: partial?.limit ?? d.limit,
  };
};

/** `page` + `pageSize` (e.g. audit trail); default size matches {@link DEFAULT_LIST_PAGE_SIZE}. */
export type TPageSizePaginationQuery = {
  page: number;
  pageSize: number;
};

export type TPageSizePaginationQueryPartial =
  Partial<TPageSizePaginationQuery>;

export const mergePageSizePaginationQuery = (
  partial?: TPageSizePaginationQueryPartial,
): TPageSizePaginationQuery => {
  const d = defaultPaginationQuery();
  return {
    page: partial?.page ?? d.page,
    pageSize: partial?.pageSize ?? d.limit,
  };
};

export type HttpBaseApiWrapper = {
  get: <T>(relativeUrl: string, options?: RequestOptions) => Promise<T>;
  post: <T>(
    relativeUrl: string,
    body?: object,
    options?: RequestOptions,
  ) => Promise<T>;
  put: <T>(
    relativeUrl: string,
    body?: object,
    options?: RequestOptions,
  ) => Promise<T>;
  patch: <T>(
    relativeUrl: string,
    body?: object,
    options?: RequestOptions,
  ) => Promise<T>;
  delete: <T>(
    relativeUrl: string,
    body?: object,
    options?: RequestOptions,
  ) => Promise<T>;
};

const baseUrl =
  import.meta.env.VITE_API_URL ?? "http://localhost:4001/v1";

export const endpointRegistry = {
  auth: `${baseUrl}/authenticate`,
  varisht: `${baseUrl}/varisht`,
  dashboard: `${baseUrl}/dashboard`,
  institute: `${baseUrl}/institutes`,
  spocPremise: `${baseUrl}/spocPremise`,
  compliance: `${baseUrl}/settings/compliance`,
  feeStructure: `${baseUrl}/admin/feeStructure`,
  academic: `${baseUrl}/academics/admin`,
  academicsRoot: `${baseUrl}/academics`,
  assessment: `${baseUrl}/assessment`,
  reportCard: `${baseUrl}/report-card`,
  branding: `${baseUrl}/branding`,
  localization: `${baseUrl}/localization`,
  rbac: `${baseUrl}/rbac`,
  auditTrail: `${baseUrl}/auditTrail`,
  users: `${baseUrl}/users`,
};

export type HttpBaseApi = Record<
  keyof typeof endpointRegistry,
  HttpBaseApiWrapper
> &
  HttpBaseApiWrapper;

export interface IApiService {
  httpAPI: HttpBaseApi;
  endpoint?: string;
}
export type TReactQueryError<T> = {
  // TODO: Remove this
  response?: {
    data: T;
    status: string | number;
  };
};
